/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CardMedia,
  Divider,
  Grid,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import AddCircularIcon from "./AddCircularIcon";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { MOBLIE_VIEW_WIDTH } from "../../constants/constants";
import Markdown from "markdown-to-jsx";
const sideParent = css`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  .MuiTabs-flexContainer {
    flex-direction: row;
    justify-content: center;
  }
  .Mui-selected {
    background-color: #1f1c1c;
  }
`;

const buttonstyle = css`
  &:hover {
    cursor: pointer;
  }
  text-align: center;
  color: white;
  font-size: 14px;
  border: 2px solid white;
  border-radius: 25px;
  width: 25%;
  min-width: 200px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
`;

const sideImage = css`
  width: 100%;
  max-height: 100%;
`;

const sideImageDiv = (matches) => css`
  width: ${matches ? "67%" : "100%"};
  height: ${matches ? "30vw" : "auto"};
  object-fit: cover !important;
`;

const tabContent = (matches, isFromFinance) => css`
  display: flex;
  flex-direction: ${matches
    ? isFromFinance
      ? "row"
      : "row-reverse"
    : "column"};
`;
const financeButton = css`
  display: flex;
  svg {
    font-size: 32px;
  }
  .MuiTypography-body1 {
    line-height: 32px;
    margin-left: 10px;
    font-size: 16px;
  }
  .MuiBox-root {
    margin: 0;
  }
`;
const descriptionWrapper = css`
  font-size: 18px;
  line-height: 35px;
`;
const fontFamilyWrapper = (theme) => css`
  font-family: ${theme.typography.MBCORPOA};
  font-size: 46px;
`;
export default function IndustryTabView({ industryTabData, isFromFinance }) {
  const [images, setImages] = useState([]);
  const [buttons, setButtons] = useState([]);
  const [headings, setHeadings] = useState([]);
  const [descriptions, setDescriptions] = useState([]);
  const [link, setLink] = useState({
    buttonLink: [],
    buttonText: [],
    isExternalLink: [],
  });
  const [value, setValue] = useState(0);
  const matches = useMediaQuery(MOBLIE_VIEW_WIDTH);

  useEffect(() => {
    const main = {
      image: [],
      button: [],
      buttonText: [],
      buttonLink: [],
      isExternalLinks: [],
      heading: [],
      description: [],
    };
    industryTabData.map((item) => {
      if (item?.media?.data?.attributes?.url) {
        if (item?.isExternalLink) {
          main.image.push(item?.isExternalLink);
        } else {
          main.image.push(
            process.env.REACT_APP_BASEURL + item?.media?.data?.attributes?.url
          );
        }
      }
      main.button.push(item?.title);
      main.buttonText.push(item?.buttonText);
      main.buttonLink.push(item?.buttonLink);
      main.isExternalLinks.push(item?.isExternalLink);
      main.heading.push(item?.heading);
      main.description.push(item?.description);
    });
    setImages([...main.image]);
    setButtons([...main.button]);
    setLink((prevState) => ({
      ...prevState,
      buttonText: main.buttonText,
      buttonLink: main.buttonLink,
      isExternalLinks: main.isExternalLinks,
    }));
    setHeadings([...main.heading]);
    setDescriptions([...main.description]);
  }, [industryTabData]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClick = (val = value) => {
    if (link.isExternalLinks[val]) {
      window.open(link.buttonLink[val]);
    } else {
      window.location = link.buttonLink[val];
    }
  };

  const sliderArray = images.map((item) => (
    <div css={sideImageDiv(matches)} key={item.toString()}>
      <CardMedia
        component="img"
        css={sideImage}
        image={item}
        alt="No Image Present"
      ></CardMedia>
    </div>
  ));

  return (
    <Grid>
      {matches ? (
        <div css={sideParent}>
          <Tabs value={value} onChange={handleChange}>
            {buttons.map((item, index) => (
              <Tab
                key={index}
                style={{
                  color: "white",
                  borderRadius: "5%",
                  fontSize: "16px",
                }}
                label={item}
              ></Tab>
            ))}
          </Tabs>
          <Divider style={{ width: "100%", borderColor: "white" }} />
          <Box
            p={10}
            pt={5}
            pr={22}
            pb={3}
            css={() => tabContent(matches, isFromFinance)}
          >
            {sliderArray[value]}
            <Box p={1} pr={8} pl={8} style={{ width: "33%" }}>
              <Typography
                variant="h3"
                style={{
                  display: "block",
                }}
                css={fontFamilyWrapper}
                gutterBottom
                pb={1}
                component="span"
              >
                {headings[value]}
              </Typography>
              <Typography
                variant="body2"
                gutterBottom
                pb={2}
                style={{ color: "white" }}
                css={descriptionWrapper}
              >
                <Markdown>{descriptions[value] || ""}</Markdown>
              </Typography>
              {link.buttonText[value] &&
                (isFromFinance ? (
                  <AddCircularIcon
                    handleClick={() => handleClick(value)}
                    buttonText={link.buttonText[value]}
                  />
                ) : (
                  <Box css={buttonstyle} onClick={() => handleClick(value)}>
                    {link.buttonText[value]}
                  </Box>
                ))}
            </Box>
          </Box>
        </div>
      ) : (
        <>
          {buttons.map((item, index) => (
            <Accordion key={index} disableGutters={true}>
              <AccordionSummary
                style={{
                  backgroundColor: "#1f1c1c",
                  color: "white",
                  fontSize: "16px",
                }}
                expandIcon={<ExpandMoreIcon style={{ color: "white" }} />}
              >
                {item}
              </AccordionSummary>
              <AccordionDetails
                style={{
                  backgroundColor: "#1f1c1c",
                  color: "white",
                  padding: 0,
                }}
              >
                <Box css={() => tabContent(matches)}>
                  {sliderArray[index]}
                  <Box p={4}>
                    <Typography variant="h5" gutterBottom pt={1} pb={1}>
                      {headings[index]}
                    </Typography>
                    <Typography
                      css={descriptionWrapper}
                      variant="body2"
                      gutterBottom
                      pb={2}
                    >
                      <Markdown>{descriptions[index] || ""}</Markdown>
                    </Typography>
                    {link.buttonText[index] &&
                      (isFromFinance ? (
                        <Box
                          css={financeButton}
                          onClick={() => handleClick(index)}
                        >
                          <AddCircularIcon
                            handleClick={() => () => handleClick(index)}
                            buttonText={link.buttonText[index]}
                          />
                        </Box>
                      ) : (
                        <Box
                          css={buttonstyle}
                          onClick={() => handleClick(index)}
                        >
                          {link.buttonText[index]}
                        </Box>
                      ))}
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>
          ))}
        </>
      )}
    </Grid>
  );
}
